import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as Sentry from '@sentry/react';
import { getIsDevelopment } from 'services/env-service';

class ErrorBoundary extends Component {
  state = {
    error: false,
  };

  componentDidCatch(error) {
    console.log(error);
    this.setState({ error: true });
    if (!getIsDevelopment()) Sentry.captureException(error);
  }

  render() {
    if (this.state.error) {
      return (
        <div>
          <h1>Ooops, an error occured</h1>
          <p>We are not able to load this content</p>
        </div>
      );
    }

    return <div>{this.props.children}</div>;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default ErrorBoundary;
